// import mockData from '../data/mocks'
import { apiBaseUrl } from '../config'
import store from '../store'

export default {
  loadData(context, data) {
    context.commit('setVideo', data)
  },
  notify(context, message) {
    context.commit('notify', Object.assign({}, message))
    if (message.sticky) {
      switch (typeof message.sticky) {
        case ('number'):
          setTimeout(() => {
            context.commit('clearNotification', message)
          }, message.sticky)
        break
      }
    }
  },
  addTrackedWaypoints(context, data) {
    context.commit('addTrackedWaypoints', data)
  },
  storeImage(context, data) {
    return new Promise((resolve, reject) => {
      console.log(store.state.user)
      fetch(`${apiBaseUrl}/api/image?token=${store.state.user.token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => {
        return res.text()
      }).then(function(imageUrl) {
        resolve(imageUrl + '?' + (new Date()).getTime())
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  deleteImageFromStore(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/image?token=${store.state.user.token}`, {
        method: "delete",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(() => {
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  translate(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/translate?token=${store.state.user.token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => {
        return res.json()
      }).then(function(data) {
          resolve(data)
      }).catch(e => {
          console.error(e)
          reject()
      });
    })
  },
  translateAll(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/translate/all?&token=${store.state.user.token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => {
        return res.json()
      }).then(function(data) {
          resolve(data)
      }).catch(e => {
          console.error(e)
          reject()
      });
    })
  },
  loadVideoTranslations(context, assetId) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/translate/export?assetId=${assetId}&token=${store.state.user.token}`, {
        method: "get"
      }).then(res => {
        return res.json()
      }).then(function(data) {
          resolve(data)
      }).catch(e => {
          console.error(e)
          reject()
      });
    })
  },
  saveVideoTranslations(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/translate/import?assetId=${data.assetId}&token=${store.state.user.token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data.translations)
      }).then(res => {
          return res.json()
      }).then(function(data) {
          resolve(data)
      }).catch(e => {
          console.error(e)
          reject()
      });
    })
  }
}
